/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-undef */
import 'dayjs/locale/lt';

import HeaderTags from '../components/common/HeaderTags';
import XTable from '../components/common/XTable';
import { HistoryDialogProvider } from '../contexts/useHistoryDialog';
import { IVAZDialogProvider } from '../contexts/useIVAZDialog';
import { PageProvider } from '../contexts/usePageContext';
import { ReportDialogProvider } from '../contexts/useReportDialog';
import useTablePage from '../hooks/useTablePage';
import { getTableStart } from '../redux/results/resultsSlice';

const NAME = 'products';
const NAME_UPPER = NAME.charAt(0).toUpperCase() + NAME.slice(1);

const ProductsPage = () => {
 const { apiRef, items, rowCount, loading, dispatch } = useTablePage(NAME);

 return (
  <PageProvider pageName={NAME}>
   <ReportDialogProvider>
    <HistoryDialogProvider>
     <IVAZDialogProvider>
      <HeaderTags title={NAME_UPPER} description={NAME_UPPER} />
      <XTable
       columns={[]}
       apiRef={apiRef}
       table={NAME}
       rows={items}
       rowCount={parseInt(rowCount, 10)}
       fetchData={(data: Record<string, unknown>) =>
        dispatch(getTableStart({ table: NAME, ...data }))
       }
       isServerMode
       loading={loading.getTable || false}
      />
     </IVAZDialogProvider>
    </HistoryDialogProvider>
   </ReportDialogProvider>
  </PageProvider>
 );
};

export default ProductsPage;
